import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxImageProps {
  src: string;
  alt: string;
  className?: string;
  overlayClassName?: string;
}
export function ParallaxImage({
  src,
  alt,
  className = '',
  overlayClassName = ''
}: ParallaxImageProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Move the image slightly slower than the scroll speed for a parallax effect
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <div ref={ref} className={`relative overflow-hidden ${className}`} data-id="element-205">
      <motion.div style={{
      y
    }} className="absolute inset-0 w-full h-[120%] -top-[10%]" data-id="element-206">
        <img src={src} alt={alt} className="w-full h-full object-cover" data-id="element-207" />
      </motion.div>
      {overlayClassName && <div className={`absolute inset-0 ${overlayClassName}`} data-id="element-208" />}
    </div>;
}